export default {
  // cookieDomain: 'localhost',
  cookieDomain: '.zwiz.app',
  ssoUrl: 'https://zwiz.app',
  // serverSSOUrl: 'http://localhost:8082/',
  serverSSOUrl: 'https://api.zwiz.app/',
  // serverUrl: 'http://localhost:8081/',
  serverUrl: 'https://d3k49jhriitw3f.cloudfront.net/',
  gbPrimeUrl: 'https://api.gbprimepay.com/',
  // gbPrimeUrl: "https://api.globalprimepay.com/",
  AuthFacebook: {
    appId: '489929571406302',
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: 'v2.8'
    // auth: true
  },
  scopeFacebook: {
    scope:
      'email,public_profile,manage_pages,pages_messaging,pages_messaging_subscriptions,read_page_mailboxes,publish_pages,page_events',
    return_scopes: true
  },
  AuthLine:
    'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656125305',
  syncLine:
    'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656125305',
  line_client_id: 1656125305,
  client_secret: '61a1552bbabc8a4c297edbdfbc5a788d',
  how_to_use_blog: 'https://blog.zwiz.app/richmenucreator/'
}
